var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1400_4171",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1400_4171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99364 17.0205C4.59886 17.0205 4.26161 16.8807 3.98189 16.6011C3.7023 16.3214 3.5625 15.9842 3.5625 15.5894V8.15998C3.5625 7.7652 3.7023 7.42795 3.98189 7.14823C4.26161 6.86864 4.59886 6.72884 4.99364 6.72884H5.9375V5.14551C5.9375 4.15698 6.28412 3.3161 6.97735 2.62286C7.67059 1.92963 8.51147 1.58301 9.5 1.58301C10.4885 1.58301 11.3294 1.92963 12.0226 2.62286C12.7159 3.3161 13.0625 4.15698 13.0625 5.14551V6.72884H14.0064C14.4011 6.72884 14.7384 6.86864 15.0181 7.14823C15.2977 7.42795 15.4375 7.7652 15.4375 8.15998V15.5894C15.4375 15.9842 15.2977 16.3214 15.0181 16.6011C14.7384 16.8807 14.4011 17.0205 14.0064 17.0205H4.99364ZM4.99364 15.833H14.0064C14.0775 15.833 14.1359 15.8102 14.1815 15.7645C14.2272 15.7189 14.25 15.6605 14.25 15.5894V8.15998C14.25 8.08886 14.2272 8.03047 14.1815 7.98482C14.1359 7.93917 14.0775 7.91634 14.0064 7.91634H4.99364C4.92252 7.91634 4.86413 7.93917 4.81848 7.98482C4.77283 8.03047 4.75 8.08886 4.75 8.15998V15.5894C4.75 15.6605 4.77283 15.7189 4.81848 15.7645C4.86413 15.8102 4.92252 15.833 4.99364 15.833ZM9.5 13.2601C9.88462 13.2601 10.2117 13.1254 10.4813 12.8559C10.7507 12.5864 10.8854 12.2593 10.8854 11.8747C10.8854 11.4901 10.7507 11.163 10.4813 10.8934C10.2117 10.624 9.88462 10.4893 9.5 10.4893C9.11538 10.4893 8.78829 10.624 8.51873 10.8934C8.2493 11.163 8.11458 11.4901 8.11458 11.8747C8.11458 12.2593 8.2493 12.5864 8.51873 12.8559C8.78829 13.1254 9.11538 13.2601 9.5 13.2601ZM7.125 6.72884H11.875V5.14551C11.875 4.48579 11.6441 3.92502 11.1823 3.46322C10.7205 3.00141 10.1597 2.77051 9.5 2.77051C8.84028 2.77051 8.27951 3.00141 7.81771 3.46322C7.3559 3.92502 7.125 4.48579 7.125 5.14551V6.72884Z",
    fill: "#001E40",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.69be72f957b949e89ed74dd7c042a8d0.svg";
export { ForwardRef as ReactComponent };